import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, Observable } from 'rxjs';
import { ENVIRONMENT, PIMSEnvironment } from 'environments';
import { VisitDetailPhotos } from '@types-lib';


@Injectable({ providedIn: 'root' })
export class MedicalPhotosEndpoints {
  private readonly env = inject<PIMSEnvironment>(ENVIRONMENT);
  private readonly http = inject(HttpClient);

  get(userId: number | string): Observable<VisitDetailPhotos.MedicalDocumentsResponse> {
    const id =
      typeof userId === 'string'
        ? Number.parseInt(userId, 10)
        : userId;

    if (!Number.isFinite(id)) {
      throw new Error(`Invalid userId: ${userId}`);
    }

    return this.http.get<VisitDetailPhotos.MedicalDocumentsResponse>(
      `${this.env.constants.ADMIN_API_URL}/users/${id}/medical-documents`,
    );
  }
}
